<template>
  <div class="watermark-container" v-if="username && $route.path !== '/login'">
    <div class="watermark-pattern" :style="patternStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'Watermark',
  data() {
    return {
      username: '',
      name:'',
      patternSize: 120 // 水印图案的大小，从150减小到120，使水印更密集
    };
  },
  computed: {
    patternStyle() {
      return {
        backgroundImage: `url("${this.generateWatermarkUrl(this.name,this.username)}")`,
        backgroundSize: `${this.patternSize}px ${this.patternSize}px`
      };
    }
  },
  methods: {
    generateWatermarkUrl(text1,text2) {
      // 创建一个Canvas元素来生成水印
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      // 设置Canvas大小
      canvas.width = this.patternSize;
      canvas.height = this.patternSize;
      
      // 设置文字样式
      ctx.font = '14px Arial';
      ctx.fillStyle = 'rgba(180, 180, 180, 0.5)'; // 加深颜色和不透明度
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // 旋转Canvas以45度角绘制文字
      ctx.translate(this.patternSize / 2, this.patternSize / 2);
      ctx.rotate(Math.PI / 4); // 45度角
      // 绘制用户名
      ctx.fillText(text1, 0, -28);
      ctx.fillText(text2, 0, -8);
      // 绘制当前日期（yyyy-MM）
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDay() + 1).padStart(2, '0');
      ctx.fillText(`${year}-${month}-${day}`, 0, 14);
      
      // 将Canvas转换为DataURL
      return canvas.toDataURL('image/png');
    },
    
    // 从localStorage或其他存储中获取用户名
    getUsernameFromStorage() {
      // 这里假设登录时将用户名存储在localStorage中
      
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      console.log('userinfo',userInfo)
      const username = userInfo.userName;
      const name = userInfo.name;      
      if (username) {
        this.username = username;
      }
      if (name) {
        this.name = name;
      }
    }
  },
  created() {
    this.getUsernameFromStorage();
  },
  // 监听路由变化，确保在路由切换时水印仍然存在
  watch: {
    '$route'() {
      this.getUsernameFromStorage();
    }
  }
};
</script>

<style scoped>
.watermark-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* 确保水印不会影响用户交互 */
  z-index: 9999; /* 确保水印在最上层 */
}

.watermark-pattern {
  width: 100%;
  height: 100%;
  background-repeat: repeat;
  opacity: 0.7; /* 增加整体不透明度，从0.5提高到0.7 */
}
</style>